import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

export async function getAudioDurationSeconds(audioBlob: Blob): Promise<number> {
  return new Promise(resolve => {
    const audioContext = new AudioContext();
    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const arrayBuffer = reader.result as ArrayBuffer;
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        resolve(audioBuffer.duration);
      } catch (error) {
        logger.error({
          message: "[audio-duration] decodeAudioData failed",
          info: { error: objectModule.safeErrorAsJson(error as Error) },
        });
        resolve(0);
      } finally {
        audioContext.close();
      }
    };

    reader.onerror = () => {
      logger.error({ message: "[audio-duration] FileReader onerror" });
      resolve(0);
      audioContext.close();
    };

    reader.readAsArrayBuffer(audioBlob);
  });
}
